const MainBoxSx = {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  };

export default MainBoxSx;